import { ExtraFee as ExtraFeeSynthesisCore} from 'quote-export-manager-core';
import {ExtraFee} from '../../../core/models/quote/extra-fee';

export class ExtraFeeV1Mapper {
  toExtraFee(fee: ExtraFee): ExtraFeeSynthesisCore {
    return new ExtraFeeSynthesisCore(
      fee.id,
      fee.uniteAmount,
      fee.percentage,
      fee.type,
      fee.label,
      fee.quantity,
      fee.totalAmount,
    );
  }
}
